import { render, staticRenderFns } from "./Computadores.vue?vue&type=template&id=277e3dea&scoped=true"
import script from "./Computadores.vue?vue&type=script&lang=js"
export * from "./Computadores.vue?vue&type=script&lang=js"
import style0 from "./Computadores.vue?vue&type=style&index=0&id=277e3dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277e3dea",
  null
  
)

export default component.exports